// removed by extract-text-webpack-plugin
module.exports = {"recaptchaContent":"Captcha__recaptchaContent","textInput":"Captcha__textInput","emptyCaptcha":"Captcha__emptyCaptcha","recaptcha":"Captcha__recaptcha","error":"Captcha__error","errorMessage":"Captcha__errorMessage","growDotQello":"Captcha__growDotQello","growDotBlue":"Captcha__growDotBlue","growDotGolden":"Captcha__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Captcha/Captcha.scss
// module id = 1844
// module chunks = 0